import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
// import { useNeomem } from '../application'
// import { useGlobals } from '../application'
// import Markdown from '../../packages/markdown'
// import ExternalLink from '../../packages/external-link'
import './styles.css'


export default observer(() => {

  return (
    <div className="sidebar-booking-com">
      <ins class="bookingaff" data-aid="1777588" data-target_aid="1777588" data-prod="banner" data-width="200" data-height="200" data-lang="en">
        <a href="//www.booking.com?aid=1777588">Booking.com</a>
      </ins>
      <script type="text/javascript">
        {
          (function(d, sc, u) {
            var s = d.createElement(sc), p = d.getElementsByTagName(sc)[0];
            s.type = 'text/javascript';
            s.async = true;
            s.src = u + '?v=' + (+new Date());
            p.parentNode.insertBefore(s,p);
          })(document, 'script', '//aff.bstatic.com/static/affiliate_base/js/flexiproduct.js')
        }
      </script>
    </div>
  )
})
